<script>
import ProInput from '$common/ProInput'

export default {
  name: 'AdminSettings',
  components: {
    'pro-input': ProInput,
  },
  data () {
    return {
      form: {
        filing_year: '',
      },
      formOptions: {
        filing_year: {
          title: 'Filing year',
          errorIf: val => (val || val === 0) && (String(val).length === 2) ? '' : 'Please input 2 numbers',
          type: 'number',
        },
      },
      settingsRef: this.$firestore.doc('system/settings'),
    }
  },
  methods: {
    async getSettings () {
      const settings = (await this.settingsRef.get()).data()
      this.form = settings
    },
    async saveSettings () {
      const errors = this.$proErrors()
      if (errors.length) return errors.forEach(err => this.$toast({copy: err, time: 2000}))

      this.$toast('Saving settings...')
      try {
        this.settingsRef.set(this.form)
        this.$toast('Saved!')
      } catch (err) {
        console.error(err)
        this.$toast('Could not save settings for some reason.')
      }
    },
  },
  mounted () {
    this.getSettings()
  },
}
</script>

<template lang="pug">
  #admin-settings-main.admin-main
    .admin-settings-container.admin-container
      .header
        .title Settings
      .content
        .pro-form
          .helper-text Use this to change the year the will appear in the upper right hand corner of 130 form. Only the last 2 digits are necessary since the first 2 are already supplied on the form.
          .form-row.filing-year
            .year-start 20
            pro-input(
              v-model='form.filing_year'
              :options='formOptions.filing_year'
            )
          .form-row
            .pro-button.major(
              @click='saveSettings'
            ) Save settings

</template>

<style lang="sass" scoped>
  #admin-settings-main
    .admin-settings-container
      .content
        .pro-form
          max-width: 400px
          .helper-text
            font-size: 12px
            margin-bottom: 1.25rem
            padding: .25rem
            background-color: $lightgrey
            border-radius: .25rem
          .filing-year
            grid-template-columns: min-content auto
            align-items: center
            .year-start
              padding: .25rem .25rem 0 0
</style>